import { useState } from "react";
import Enums from "../../utilities/enum";
import { DateRangePicker } from "../shared/dateRangePicker";
import { SearchFiltersModal } from "../shared/searchFiltersModal";
import stringHelpers from "../../utilities/stringHelpers";
import { toDateString } from "../../utilities/dateUtilities";
import { TagSelector } from "../shared/tagSelector";
import appliedFiltersUtilities from "../../utilities/appliedFiltersUtilities";
import arrayUtilities from "../../utilities/arrayUtilities";

export const BreachesFiltersModal = ({
	showModal,
	handleClose,
	handleConfirm,
	initialFilterStart,
	initialFilterEnd,
	initialType,
	initialIsAssigned,
	initialSelectedTags = [],
	initialAppliedFilters,
	showIsAssignedFilter = true,
	tags = []
}) => {
	const [filterStart, setFilterStart] = useState(initialFilterStart)
	const [filterEnd, setFilterEnd] = useState(initialFilterEnd)
	const [type, setType] = useState(initialType)
	const [isAssigned, setIsAssigned] = useState(initialIsAssigned)
	const [selectedTags, setSelectedTags] = useState(initialSelectedTags)
	const [appliedFilters, setAppliedFilters] = useState(initialAppliedFilters)

	const clearLocalFilters = () => {
		setFilterStart(null)
		setFilterEnd(null)
		setType(null)
		setIsAssigned(null)
		setSelectedTags([])
		setAppliedFilters(null)
	}

	const handleTagsChange = tagSelections => {
		setSelectedTags(tagSelections)
		setAppliedFilters(prevState => appliedFiltersUtilities.applyMultiSelection(prevState, "Tags", tagSelections, tags))
	}

	return (
		<SearchFiltersModal
			title="Filter Results"
			handleClose={ handleClose }
			handleConfirm={ () => handleConfirm({ filterStart, filterEnd, type, isAssigned, selectedTags, appliedFilters }) }
			showModal={ showModal }
			key="breaches-dashboard-filters-modal"
			handleReset={ clearLocalFilters }
		>
			<div className="w-100">
				<div className="mb-2">
					<label className="m-0 mr-2 mb-1 nowrap">Date Range</label>
					<DateRangePicker
						fromDate={ filterStart }
						toDate={ filterEnd }
						setDateRange={ (firstDate, lastDate, presetLabel) => {
							const isFirstDateEmpty = firstDate === null || firstDate === ""
							const isLastDateEmpty = lastDate === null || lastDate === ""
							setFilterStart(isFirstDateEmpty ? null : firstDate);
							setFilterEnd(isLastDateEmpty ? null : lastDate);
							if (!stringHelpers.isNullOrEmpty(presetLabel)) {
								setAppliedFilters(prevState => {
									const updatedFilters = { ...prevState }
									delete updatedFilters.From
									delete updatedFilters.To
									updatedFilters["Date Range"] = presetLabel
									return updatedFilters
								})
							}
							else {
								setAppliedFilters(prevState => {
									const updatedFilters = { ...prevState }
									if (!isFirstDateEmpty && !isLastDateEmpty) {
										delete updatedFilters.From
										delete updatedFilters.To
										updatedFilters["Date Range"] = `${toDateString(new Date(firstDate))} - ${toDateString(new Date(lastDate))}`
									} else {
										if (!isFirstDateEmpty) {
											updatedFilters.From = toDateString(new Date(firstDate))
										} else {
											delete updatedFilters.From
										}
										if (!isLastDateEmpty) {
											updatedFilters.To = toDateString(new Date(lastDate))
										} else {
											delete updatedFilters.To
										}
										delete updatedFilters["Date Range"]
									}
									return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
								})
							}
						}}
						showClearOption
						hideLabel
						fullWidth
						dropdownPositionRight
					/>
				</div>

				<div className="d-flex flex-column mb-2">
					<label className="m-0 mr-2 mb-1 nowrap">Type</label>
					<select
						value={ type === null ? "" : type }
						onChange={ e => {
							const value = stringHelpers.isNullOrEmpty(e.target.value) ? null : Number(e.target.value)
							setType(value)
							setAppliedFilters(prevState => {
								const updatedFilters = { ...prevState }
								if (value === null) {
									delete updatedFilters["Type"]
								} else {
									updatedFilters["Type"] = Enums.ContraventionTypes[value]
								}
								return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
							})
						} }
						className="border rounded px-2 py-1 w-100"
					>
						<option value="">All</option>
						{
							Object
								.entries(Enums.ContraventionTypes)
								.map(([key, value]) => <option value={ key }>{ value }</option>)
						}
					</select>
				</div>

				{
					showIsAssignedFilter &&
					<div className="d-flex flex-column mb-2">
						<label className="m-0 mr-2 mb-1 nowrap">Allocation</label>
						<select
							value={ isAssigned === true ? "true" : isAssigned === false ? "false" : "" }
							onChange={ e => {
								const value = e.target.value === "true" ? true : e.target.value === "false" ? false : null
								setIsAssigned(value)
								setAppliedFilters(prevState => {
									const updatedFilters = { ...prevState }
									if (value === null) {
										delete updatedFilters["Allocation"]
									} else {
										updatedFilters["Allocation"] = value ? "Allocated" : "Unallocated"
									}
									return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
								})
							} }
							className="border rounded px-2 py-1 w-100"
						>
							<option value="">All</option>
							<option value="true">Allocated</option>
							<option value="false">Unallocated</option>
						</select>
					</div>
				}

				{ !arrayUtilities.isNullOrEmpty(tags) && <div className="d-flex flex-column mb-2">
					<div className="d-flex align-items-center justify-content-between">
						<label className="m-0 mr-2 mb-1 nowrap">Tags</label>
						<button onClick={ () => handleTagsChange([]) } className="btn btn-none m-0 p-0 fs--1 mb-1" type="button">Clear tags</button>
					</div>
					<TagSelector
						onChange={ handleTagsChange }
						selectedTags={ selectedTags }
						tags={ tags }
					/>
				</div> }
			</div>
		</SearchFiltersModal>
	)
}
